@if (isLoading) {
<div class="container justify-center vh-100">
  <div class="d-flex justify-content-center align-items-center flex-column h-100 demo-container">
    @if (getAppThemeName() !== 'nb') {
    <db-icon size="120px" class="mb-3">{{getAppThemeName() + 'logo'}}</db-icon>
    }
    @if (getAppThemeName() === 'nb') {
    <svg
      class="mb-3"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 165 50"
      width="165"
      height="50"
      role="img"
      aria-hidden="true"
      focusable="false"
      style="forced-color-adjust: none">
      <path fill="#c8041f" d="M158.681 0H6.319C2.828 0 0 2.835 0 6.333V37h165V6.333C165 2.835 162.171 0 158.681 0" />
      <path fill="#f08701" d="M0 40v3.587C0 47.13 2.828 50 6.319 50H158.68c3.491 0 6.319-2.87 6.319-6.413V40H0" />
      <path
        fill="#fff"
        d="M40.737 13.203c3.096 1.474 5.469 5.253 4.892 9.376-.694 4.947-5.262 8.395-10.198 7.696-4.939-.695-8.371-5.272-7.688-10.22.579-4.199 3.982-7.372 8.32-7.806-5.138 1.904-7.082 6.608-7.055 6.875.014.135.074.55.194.885.124.339.432.824.432.824s1.499-6.273 7.66-8.576c.153.017.285.024.361.034-5.525 2.341-7.204 9.357-7.204 9.465 0 .054.281.43.507.663.27.278.78.616.78.616s1.238-8.209 6.865-10.595c.113.024.184.034.319.07-5.527 2.744-5.919 11.133-5.93 11.322-.001.049.418.313.711.471.355.189.96.377.96.377s-.485-8.976 5.122-11.886c.115.039.319.118.319.118-5.394 3.539-3.923 12-3.876 12.19.008.037.49.135.81.185.398.065 1.026.081 1.026.081s-2.528-8.183 2.673-12.165zm108.298 16.012-5.834-8.302v8.302h-4.851V6.5h4.851v13.862l5.604-6.745h5.054l-6.209 6.745 6.959 8.852h-5.574zm-19.174 0V18.25c0-1.621-1.389-2.315-3.178-2.315-.897 0-1.732.142-2.281.345v12.935h-4.871V14.371c1.732-.666 4.387-1.158 7.324-1.158 5.086 0 7.886 1.564 7.886 4.977v11.025h-4.88zm-18.445-8.274c-3.409.318-5.749.895-5.749 3.558 0 1.882 1.358 2.692 3.552 2.692.954 0 1.706-.174 2.196-.406v-5.844zm-2.483 8.681c-5.228 0-7.883-1.766-7.883-4.948 0-4.141 4.792-5.236 10.367-5.702v-.782c0-1.734-1.36-2.255-3.409-2.255-1.704 0-3.61.432-4.792.925l-1.041-2.49c1.271-.489 3.668-1.158 6.759-1.158 4.099 0 7.075 1.535 7.075 5.73v9.521c-1.505.694-3.989 1.159-7.076 1.159zM90.365 15.819c-.928 0-1.618.116-2.196.376V26.64c.434.201 1.04.32 1.907.32 2.742 0 4.072-2.257 4.072-5.701 0-3.125-1.042-5.44-3.783-5.44zm-.551 13.803c-3.059 0-5.285-.492-6.498-1.159V6.5h4.853v7.381c.836-.321 1.963-.61 3.608-.61 4.334 0 7.339 3.126 7.339 7.727 0 5.413-3.322 8.624-9.302 8.624zm-16.374 0c-2.226 0-4.333-.549-5.429-1.159l1.214-2.778c.722.463 2.165.926 3.525.926 1.47 0 2.625-.867 2.625-1.909 0-3.126-6.842-1.794-6.842-6.656 0-2.547 2.424-4.834 6.207-4.834 2.283 0 3.842.435 5.257 1.158l-1.185 2.49c-.549-.348-1.673-.839-2.974-.839-1.531 0-2.455.811-2.455 1.764 0 2.982 7.076 1.851 7.076 6.802-.001 2.691-2.688 5.035-7.019 5.035zM62.872 11.276c-1.503 0-2.689-.955-2.689-2.112 0-1.158 1.185-2.112 2.689-2.112 1.499 0 2.711.955 2.711 2.112s-1.212 2.112-2.711 2.112zm-2.428 2.342h4.881v15.597h-4.881V13.618zm-3.493 2.75c-1.329-.432-3.062-.463-4.017-.057v12.905h-4.879V14.371c1.79-.723 4.099-1.158 7.595-1.158.78 0 1.734.058 2.225.117l-.924 3.038zM20.639 29.215V18.25c0-1.621-1.386-2.315-3.177-2.315-.894 0-1.732.142-2.281.345v12.935H10.3V14.371c1.734-.666 4.391-1.158 7.338-1.158 5.08 0 7.882 1.564 7.882 4.977v11.025h-4.881zM0 40h165v-3H0z" />
    </svg>
    }
    <db-spinner></db-spinner>
  </div>
</div>
}
@if (!isLoading) {
<div class="container">
  @if (consentLangObject && consentLangObject.consentAgreementText) {
  <p class="mt-8">
    <strong>{{ replacePlaceholder(consentLangObject.consentAgreementText.shortText, 'not_html') }}</strong></p>
  }

  @if (consentLangObject && consentLangObject.consentAgreementText) {
  <div class="mt-8"
        [innerHTML]="replacePlaceholder(consentLangObject.consentAgreementText.agreementText, 'not_html') | keepHtml:'html'"></div>
  }

  <div class="content-area p-0">
    @if (consentLangObject && consentLangObject.scopes) {
    <db-panel class="mb-3">
      <div class="db-panel__container d-flex flex-column ml-0 bg-color-nb-grey-200">
        <db-checkbox class="mb-3" (change)="onSelectAllCheck()"
                     [model]="selectAllScopeChecked">{{ 'CONSENT_FORM.select_all' | translate }}
        </db-checkbox>
          @if (consentLangObject && consentLangObject.scopes) {
          <db-checkbox-group>
            @for (item of consentLangObject.scopes; track item; let i = $index) {
            <db-checkbox (change)="checkScope(i)"
                         [model]="item.model" [name]="item.name">
              {{ item.scopeDisplayText }}
            </db-checkbox>
            }
          </db-checkbox-group>
          }
      </div>
    </db-panel>
    }

    @if (consentLangObject && consentLangObject.consentTextAddOn) {
    <ng-container>
      @for (consentTextAddOn of consentLangObject.consentTextAddOn; track consentTextAddOn;) {
      <db-toggleable
        label="{{replacePlaceholder(consentTextAddOn.shorttext, 'not_html')}}"
        iconPosition="right" class="border-tb">
          <div class="{{'toggleable__content-' + getAppThemeName()}}" [innerHTML]="replacePlaceholder(consentTextAddOn.text, 'not_html') | keepHtml:'html'"></div>
      </db-toggleable>
      }
    </ng-container>
    }

    @if (consentLangObject && consentLangObject.consentAgreementText.acceptanceText) {
    <db-alert status="info" design="notification" class="agreement-text">
      <p [innerText]="replacePlaceholder(consentLangObject.consentAgreementText.acceptanceText, 'not_html') | keepHtml:'not_html'"></p>
    </db-alert>
    }

    <div class="d-flex flex-row justify-content-between my-8 w-100">
      <db-button design="secondary" (click)="onCancelConsent()" (keydown)="onCancelConsent()" [loading]="isFormCancelBtnLoading" [disabled]="isFormCancelBtnLoading || isFormConfirmBtnLoading">{{ 'GLOBAL.cancel_btn_txt' | translate }}</db-button>
      <db-button design="primary" (click)="onAgreeConsent()" (keydown)="onAgreeConsent()" [loading]="isFormConfirmBtnLoading"
                 [disabled]="agreeBtnDisabled || isFormCancelBtnLoading || isFormConfirmBtnLoading">{{ 'GLOBAL.agree_btn_txt' | translate }}
      </db-button>
    </div>

  </div>
</div>
}
